import React from 'react';

import {
  PageTile,
  TabContent,
  TabMenu,
  TabMenuContainer,
} from '@make-software/cspr-design';
import { TabMenuItem } from '@block-explorer/ui';
import { useTabsState } from '../../../router/navigation';
import { useTranslation } from 'react-i18next';
import AccountDeployList from './AccountDeployList';
import AccountRewardList from './AccountRewardList';
import AccountTransferList from './AccountTransferList';
import AccountDelegationsList from './AccountDelegationsList';
import AccountNamedKeysList from './AccountNamedKeysList';
import AccountNFTTokensList from './AccountNFTTokensList';
import AccountTokensList from './AccountTokensList';
import { AccountTokensTxsList } from './AccountTokensTxsList';

export interface AccountDataListsProps {
  publicKey: string;
  accountHash: string;
}

export const AccountTabs = ({
  publicKey,
  accountHash,
}: AccountDataListsProps) => {
  const { isTabActive, setTabActive } = useTabsState('AccountDataLists');
  const { t } = useTranslation();

  const tabs = [
    {
      name: t('Transactions'),
      render: () => <AccountDeployList publicKey={publicKey} />,
    },
    {
      name: t('Native Transfers'),
      render: () => <AccountTransferList accountHash={accountHash} />,
    },
    {
      name: t('Token Txs', 'Token Txs'),
      render: () => (
        <AccountTokensTxsList accountHash={accountHash} publicKey={publicKey} />
      ),
    },
    {
      name: t('Tokens', 'Tokens'),
      render: () => <AccountTokensList accountHash={accountHash} />,
    },
    {
      name: t('NFT', 'NFT'),
      render: () => <AccountNFTTokensList accountHash={accountHash} />,
    },
    {
      name: t('Delegations', 'Delegations'),
      render: () => <AccountDelegationsList publicKey={publicKey} />,
    },
    {
      name: t('Staking Rewards', 'Staking Rewards'),
      render: () => <AccountRewardList publicKey={publicKey} />,
    },
    {
      name: t('Named keys'),
      render: () => <AccountNamedKeysList accountHash={accountHash} />,
    },
  ];

  return (
    <PageTile>
      <TabMenuContainer tabsCount={tabs.length}>
        <TabMenu>
          {tabs.map((tab, index) => (
            <TabMenuItem
              key={`${tab.name}-${isTabActive(index)}`}
              active={isTabActive(index)}
              onClick={() => setTabActive(index)}
            >
              {tab.name}
            </TabMenuItem>
          ))}
        </TabMenu>
      </TabMenuContainer>

      {tabs.map((tab, index) => (
        <TabContent key={tab.name}>
          {isTabActive(index) && tab.render()}
        </TabContent>
      ))}
    </PageTile>
  );
};

export default AccountTabs;
